import { parseTemplateFieldConfig } from './parse-template-field-config.js';
import { evaluateRules } from './rule-evaluator.js';
import { SETTABLE_CORE_FIELD_IDS, } from './rule-types.js';
/** Folds each field's always-required flag and the template's base gates into the rule evaluation. */
export function evaluateCalEventTemplate({ fields, rules, baseGates, values, }) {
    const evaluation = evaluateRules(fields.map((field) => ({ id: field.id, type: field.typeId })), rules, { ...values, ...baseGates });
    const required = { ...evaluation.required };
    for (const field of fields) {
        if (parseTemplateFieldConfig(field.typeId, field.config).required)
            required[field.id] = true;
    }
    const gates = Object.fromEntries(SETTABLE_CORE_FIELD_IDS.map((gate) => [
        gate,
        (evaluation.defaults[gate] ?? baseGates[gate]) === true || required[gate] === true,
    ]));
    return { ...evaluation, required, gates };
}
//# sourceMappingURL=evaluate-cal-event-template.js.map